import React from 'react';
import { AlertCircleIcon, CheckIcon } from 'lucide-react';
const PricingSection = () => {
  return <section id="pricing" className="py-20 px-6 md:px-12 bg-white" data-id="element-144">
      <div className="max-w-5xl mx-auto" data-id="element-145">
        <div className="text-center mb-16" data-id="element-146">
          <span className="bg-teal-100 text-teal-800 px-4 py-1 rounded-full text-sm font-semibold inline-block mb-4" data-id="element-147">
            LIMITED TIME OFFER
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-teal-900 mb-6" data-id="element-148">
            This Is a Founding Practitioner Offer
          </h2>
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-149">
            <AlertCircleIcon className="h-6 w-6 text-teal-700" data-id="element-150" />
            <p className="text-xl font-semibold text-teal-800" data-id="element-151">
              We're opening just 10 spots at $499/year.
            </p>
          </div>
          <p className="text-lg text-gray-700 mb-8" data-id="element-152">
            Once those are filled, the price increases to $1,099/year.
          </p>
        </div>
        <div className="bg-teal-50 p-8 md:p-12 rounded-xl shadow-md mb-12" data-id="element-153">
          <h3 className="text-2xl font-bold text-teal-900 mb-6" data-id="element-154">
            We're doing this to:
          </h3>
          <div className="space-y-4" data-id="element-155">
            <div className="flex items-start" data-id="element-156">
              <div className="bg-teal-100 p-1 rounded-full mr-3 mt-1" data-id="element-157">
                <CheckIcon className="h-4 w-4 text-teal-700" data-id="element-158" />
              </div>
              <p className="text-lg text-gray-800" data-id="element-159">
                Build with feedback from real therapists
              </p>
            </div>
            <div className="flex items-start" data-id="element-160">
              <div className="bg-teal-100 p-1 rounded-full mr-3 mt-1" data-id="element-161">
                <CheckIcon className="h-4 w-4 text-teal-700" data-id="element-162" />
              </div>
              <p className="text-lg text-gray-800" data-id="element-163">
                Get the most supportive practitioners in early
              </p>
            </div>
            <div className="flex items-start" data-id="element-164">
              <div className="bg-teal-100 p-1 rounded-full mr-3 mt-1" data-id="element-165">
                <CheckIcon className="h-4 w-4 text-teal-700" data-id="element-166" />
              </div>
              <p className="text-lg text-gray-800" data-id="element-167">
                Reward our early believers with lifetime locked-in pricing
              </p>
            </div>
          </div>
        </div>
        <div className="relative" data-id="element-168">
          {/* Price comparison badge */}
          <div className="absolute -top-5 right-5 md:right-10 bg-red-500 text-white px-4 py-2 rounded-lg font-bold transform rotate-6 shadow-lg z-10" data-id="element-169">
            Save $600/year
          </div>
          <div className="bg-white border-2 border-teal-700 rounded-xl overflow-hidden shadow-lg relative" data-id="element-170">
            <div className="absolute top-0 right-0 bg-teal-800 text-white py-1 px-3 text-sm" data-id="element-171">
              Limited Time
            </div>
            <div className="bg-teal-700 py-6 px-8 text-center" data-id="element-172">
              <h3 className="text-2xl font-bold text-white" data-id="element-173">
                Founding Practitioner Offer
              </h3>
              <div className="mt-4 flex flex-col md:flex-row items-center justify-center gap-3" data-id="element-174">
                <div className="flex items-center" data-id="element-175">
                  <span className="text-4xl font-bold text-white" data-id="element-176">$499</span>
                  <span className="text-white ml-1" data-id="element-177">/year</span>
                </div>
                <div className="text-teal-200 text-sm md:text-base flex items-center" data-id="element-178">
                  <span className="line-through" data-id="element-179">
                    $1,099/year regular price
                  </span>
                </div>
              </div>
            </div>
            <div className="p-8" data-id="element-180">
              <ul className="space-y-4 mb-8" data-id="element-181">
                <li className="flex items-start" data-id="element-182">
                  <span className="text-teal-700 font-bold mr-2" data-id="element-183">✓</span>
                  <span data-id="element-184">Lifetime access to all current programs</span>
                </li>
                <li className="flex items-start" data-id="element-185">
                  <span className="text-teal-700 font-bold mr-2" data-id="element-186">✓</span>
                  <span data-id="element-187">All future updates and new programs</span>
                </li>
                <li className="flex items-start" data-id="element-188">
                  <span className="text-teal-700 font-bold mr-2" data-id="element-189">✓</span>
                  <span data-id="element-190">Unlimited client accounts</span>
                </li>
                <li className="flex items-start" data-id="element-191">
                  <span className="text-teal-700 font-bold mr-2" data-id="element-192">✓</span>
                  <span data-id="element-193">Biweekly live support calls for your clients</span>
                </li>
                <li className="flex items-start" data-id="element-194">
                  <span className="text-teal-700 font-bold mr-2" data-id="element-195">✓</span>
                  <span data-id="element-196">
                    Directory listing on our Body-Based Healing Network
                  </span>
                </li>
                <li className="flex items-start" data-id="element-197">
                  <span className="text-teal-700 font-bold mr-2" data-id="element-198">✓</span>
                  <span data-id="element-199">
                    Price locked in for life (renews annually at $499)
                  </span>
                </li>
              </ul>
              <div className="space-y-4" data-id="element-200">
                <a href="https://www.neurotoned.com/offers/7S2eZfYL?coupon_code=PROFESSIONALACCESSPASS" className="w-full bg-teal-700 hover:bg-teal-800 text-white py-3 px-6 rounded-md font-medium transition duration-300 block text-center" data-id="element-201">
                  Secure Your Spot Here
                </a>
                <a href="https://calendly.com/madisonstarr/30min" className="w-full border-2 border-teal-700 text-teal-700 hover:bg-teal-50 py-3 px-6 rounded-md font-medium transition duration-300 block text-center" data-id="element-202">
                  Book a Free 15-Min Call
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default PricingSection;